import React from 'react';

const row = (key: number) => (
  <div key={key} className="reorder-skeleton__row">
    <div className="reorder-skeleton__handle" />
    <div className="reorder-skeleton__body">
      <div className="reorder-skeleton__strip">
        {Array.from({length: 5}).map((_, i) => (
          <div key={i} className="reorder-skeleton__thumb" />
        ))}
      </div>
      <div className="reorder-skeleton__meta">
        <div className="reorder-skeleton__title" />
        <div className="reorder-skeleton__subtitle" />
      </div>
    </div>
    <div className="reorder-skeleton__order" />
  </div>
);

const ReorderSkeleton = () => (
  <div className="reorder-skeleton">
    {Array.from({length: 6}).map((_, i) => row(i))}
  </div>
);

export default ReorderSkeleton;
